const loadProjects = 'LOAD_PROJECTS';
const selectProject = 'SELECT_PROJECTS';
const startLoading = 'START_LOADING';
const stopLoading = 'STOP_LOADING';
const initialState = { projects: [], isInLoading: false };

export const actionCreators = {
    loadProjects: (name) => async (dispatch, getState) => {
        dispatch({ type: startLoading });
        fetch('api/Project?name=' + name , {
            method: 'GET',
            body: null,
        }).then(function (res) {
            if (res.status === 401) {
                dispatch({ type: 'REDIRECT', page: '/login' });
            }
            else {
                res.json().then((result) => {
                    dispatch({ type: loadProjects, result });
                }).catch((err) => console.log(err));
            }
        });
    },

    onProjectSelect: (projectId) => async (dispatch, getState) =>  {
        dispatch({ type: selectProject, projectId });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === loadProjects) {
        return { ...state, projects: action.result, isInLoading: false };
    }

    if (action.type === startLoading) {
        return { ...state, isInLoading: true };
    }

    if (action.type === stopLoading) {
        return { ...state, isInLoading: false };
    }

    if (action.type === selectProject) {
        var projects = state.projects.map(function (p) {
            p.selected = p.id === action.projectId;
            return p;
        });
        return { ...state, projects };
    }

    return state;
};
